import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { LogoutComponent } from './pages/logout/logout.component';

const routes: Routes = [
  {
    path: 'auth',
    component: MsalRedirectComponent,
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'item-review',
    loadChildren: () =>
      import('./pages/item-review/item.module').then((m) => m.ItemModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'branch-review',
    loadChildren: () =>
      import('./pages/branch-review/branch-review.module').then(
        (m) => m.BranchReviewModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'search-gtin',
    loadChildren: () =>
      import('./pages/gtin-search/gtin-search.module').then(
        (m) => m.GtinSearchModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'tender-type',
    loadChildren: () =>
      import('./pages/tender-type/tender-type.module').then(
        (m) => m.TenderTypeModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '**',
    component: HomeComponent,
  },
];

const isIframe = window !== window.parent && !window.opener;
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      // initialNavigation: !isIframe ? 'enabled' : 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
